import React, { Fragment } from 'react';
import sad from 'assets/images/other-images/sad.png';
import { Link } from 'react-router-dom';
import { Container, Button, Media, Col } from "reactstrap"
import { BACK_TO_HOME_PAGE } from "Utils/Constant";
import { H2, P } from 'Core/Components';
import { useAuth } from 'Utils/Hooks/useAuth';

const Error400 = () => {
    // Get current admin
    const { currentAdmin } = useAuth();

    // Function to check if the user type has access to a specific route
    const hasAccess = (routeUserType) => {
        return currentAdmin?.user_type === routeUserType;
    };
    return (
        <Fragment>
            <div className="page-wrapper">
                <div className="error-wrapper">
                    <Container>
                        <Media body className="img-100" src={sad} alt="" />
                        <div className="error-heading">
                            <H2 attrH2={{ className: "headline font-info" }} >{"400"}</H2>
                        </div>
                        <Col md="8 offset-md-2">
                            <P attrPara={{ className: "sub-content" }}>{"The page you are attempting to reach is currently not available. This may be because the page does not exist or has been moved."}</P>
                        </Col>
                        {hasAccess('ADMIN') && (
                            <Link to={`${process.env.PUBLIC_URL}/dashboard/report`}><Button color="info-gradien" size='lg'>{BACK_TO_HOME_PAGE}</Button></Link>
                        )}
                        {hasAccess('USER') && (
                            <Link to={`${process.env.PUBLIC_URL}/partner/report`}><Button color="info-gradien" size='lg'>{BACK_TO_HOME_PAGE}</Button></Link>
                        )}
                    </Container>
                </div>
            </div>
        </Fragment>
    );
};

export default Error400;